import { isDemoDeployment } from '@/utils/deployment'
import { apiCall } from './axiosInstance'
import { exportersApi as demoExportersApi } from './demo/exportersApi'

export const EXPORTER_TYPES = ['http', 'kafka', 'websocket'] as const
export type ExporterType = (typeof EXPORTER_TYPES)[number]

export const EXPORTER_FORMATS = ['json', 'parquet' /* 'avro',  'protobuf'*/] as const
export type ExporterFormat = (typeof EXPORTER_FORMATS)[number]

export const EXPORTER_COMPRESSIONS = ['none', 'gzip', 'zstd', 'lz4'] as const
export type ExporterCompression = (typeof EXPORTER_COMPRESSIONS)[number]

export interface Exporter {
	id: string
	stream_id: string
	connection_config?: string
	name: string
	exporter_type: ExporterType
	lap: number
	file_number: number
	columns: string[]
	device_ids: string[] | null
	metadata_keys: string[]
	metadata_filters?: Record<string, string[]> | null
	format: ExporterFormat
	compression: ExporterCompression
	column_mapping: Record<string, string>
	is_active: boolean
	target_config: Record<string, unknown>
	created_by: string
	created_at: string
	updated_at: string
	last_error?: string | null
	last_error_timestamp?: string | null
}
export interface CreateExporterPayload {
	stream_id: string
	connection_config?: string
	name: string
	exporter_type: ExporterType
	lap?: number
	file_number?: number
	columns?: string[]
	device_ids?: string[] | null
	metadata_keys?: string[]
	metadata_filters?: Record<string, string[]> | null
	format: ExporterFormat
	compression: ExporterCompression
	column_mapping?: Record<string, string>
	is_active: boolean
	target_config: Record<string, unknown>
}

// for update, fields are optional and exporter_type cannot be updated
export type UpdateExporterPayload = Omit<Partial<CreateExporterPayload>, 'exporter_type'>
interface ExportersResponse {
	count?: number
	data: Exporter[]
}
export interface StatusResponse {
	status: string
}
export interface CreateExporterResponse extends StatusResponse {
	id: string
}

const v3ExportersApi = {
	getExporters: async (page?: number, perPage?: number): Promise<ExportersResponse> => {
		const queryParams = page !== undefined && perPage !== undefined ? `?page=${page}&per_page=${perPage}` : ''
		return apiCall(`/v3/exporters${queryParams}`, { method: 'GET' })
	},
	getExporter: async (id: string): Promise<Exporter> => {
		return apiCall(`/v3/exporters/${encodeURIComponent(id)}`, { method: 'GET' })
	},
	createExporter: async (payload: CreateExporterPayload): Promise<CreateExporterResponse> => {
		return apiCall('/v3/exporters', {
			method: 'POST',
			data: payload,
		})
	},
	updateExporter: async (id: string, payload: UpdateExporterPayload): Promise<StatusResponse> => {
		return apiCall(`/v3/exporters/${encodeURIComponent(id)}`, {
			method: 'PATCH',
			data: payload,
		})
	},
	deleteExporter: async (id: string): Promise<StatusResponse> => {
		return apiCall(`/v3/exporters/${encodeURIComponent(id)}`, {
			method: 'DELETE',
		})
	},
}

export const exportersApi = isDemoDeployment() ? demoExportersApi : v3ExportersApi
